import { Model } from "@shared/models/model";

export class Alphabet extends Model {
  constructor(public arabicBased: string, public englishBased: string) {
    super();
  }
}
